import { Button, Toggle, _decorator } from 'cc';
import GameDependency from '../../../System/GameDependency';

const { ccclass, property, requireComponent } = _decorator;

@ccclass('ToggleSoundEffect')
@requireComponent(Toggle)
export default class ToggleSoundEffect extends GameDependency {
    @property
    private readonly onAudioClipKey = '';

    @property
    private readonly offAudioClipKey = '';

    protected onLoad() {
        const toggle = this.getComponent(Toggle);
        this.node.on(Button.EventType.CLICK, () => {
            if (toggle.isChecked) {
                this.game.audio.playEffect(this.offAudioClipKey);
            } else {
                this.game.audio.playEffect(this.onAudioClipKey);
            }
        });
    }
}
